import React, { lazy } from "react";
import Login from "../pages/auth/login";
import LoginWIthUser from "../pages/auth/loginWithUsername";
import { t } from "i18next";
import GameSection from "../pages/gameSection";
import CasinoProvider from "../pages/games/casino-provider";
import CasinoGames from "../pages/games/casino-games";
import ContactUs from "../pages/contactUs/ContactUs";
const NotFound = lazy(() => import("../pages/not-found"));
const HomeScreen = lazy(() => import("../pages/home-screen"));
const EmailVerification = lazy(() =>
  import("../pages/auth/email-verification")
);
const SignUp = lazy(() => import("../pages/auth/signup"));
const ForgotPassword = lazy(() => import("../pages/auth/forgot-password"));
const FormBuilder = lazy(() => import("../pages/form-builder/index"));
const ForgotPwdVerification = lazy(() =>
  import("../pages/auth/forgotpwd-verification")
);
const KycOtp = lazy(() => import("../pages/form-builder/otp-verification"));
const Leaderboard = lazy(() => import("../pages/leaderboard"));
const Mission = lazy(() => import("../pages/mission"));
const Loyalty = lazy(() => import("../pages/loyalty"));
const CasinoSection = lazy(() => import("../pages/casino"));
const Wallet = lazy(() => import("../pages/wallet/index"));
const ProfileDetails = lazy(() => import("../pages/profile/profile-details"));
const PaymentDetails = lazy(() => import("../pages/payment/index"));
const MyBets = lazy(() => import("../pages/bets/my-bets"));
const BetProfitLoss = lazy(() => import("../pages/bets/bet-profit-loss"));
const ReferralEarning = lazy(() => import("../pages/referral-earning"));
const Notification = lazy(() => import("../pages/auth/notification"));
const ProviderGames = lazy(() => import("../pages/games/provider-games"));
const CMS = lazy(() => import("../pages/cms/cms"));
const Bonus = lazy(() => import("../pages/bonus/index"));

export const openRoutes = [
  {
    layout: <Login />,
    path: "/signin",
    name: "Login",
    isAuthProtected: false,
  },
  {
    layout: <LoginWIthUser />,
    path: "/signin-username",
    name: "LoginWIthUser",
    isAuthProtected: false,
  },

  {
    layout: <EmailVerification />,
    path: "/email-verification",
    name: "EmailVerification",
    isAuthProtected: false,
  },
  {
    layout: <SignUp />,
    path: "/signup",
    name: "SignUp",
    isAuthProtected: false,
  },
  {
    layout: <ForgotPassword />,
    path: "/forgot-password",
    name: "ForgotPassword",
    isAuthProtected: false,
  },
  {
    layout: <FormBuilder />,
    path: "/kyc-verification",
    name: "KYCVerification",
    isAuthProtected: false,
  },

  {
    layout: <KycOtp />,
    path: "/kyc-otp-verification",
    name: "KycOtp",
    isAuthProtected: false,
  },
  {
    layout: <ForgotPwdVerification />,
    path: "/forgot-password-verification",
    name: "ForgotPwdVerification",
    isAuthProtected: false,
  },
  {
    layout: <NotFound />,
    path: "/not-found",
    name: "NotFound",
    isAuthProtected: false,
  },
];
export const privateRoutes = [
  {
    layout: <Login />,
    path: "/signin",
    name: "Login",
    isAuthProtected: false,
  },
  {
    layout: <LoginWIthUser />,
    path: "/signin-username",
    name: "LoginWIthUser",
    isAuthProtected: false,
  },
  {
    layout: <EmailVerification />,
    path: "/email-verification",
    name: "EmailVerification",
    isAuthProtected: false,
  },
  {
    layout: <SignUp />,
    path: "/signup",
    name: "SignUp",
    isAuthProtected: false,
  },
  {
    layout: <HomeScreen />,
    path: "",
    name: "HomeScreen",
    isAuthProtected: false,
  },
  {
    layout: <ReferralEarning />,
    path: "referral-earning",
    name: "ReferralEarning",
    isAuthProtected: true,
  },
  {
    layout: <Notification />,
    path: "notification",
    name: "Notification",
    isAuthProtected: true,
  },
  {
    layout: <ForgotPassword />,
    path: "/forgot-password",
    name: "ForgotPassword",
    isAuthProtected: false,
  },
  {
    layout: <FormBuilder />,
    path: "/kyc-verification",
    name: "KYCVerification",
    isAuthProtected: false,
  },
  {
    layout: <ForgotPwdVerification />,
    path: "/forgot-password-verification",
    name: "ForgotPwdVerification",
    isAuthProtected: false,
  },
  {
    layout: <KycOtp />,
    path: "/kyc-otp-verification",
    name: "KycOtp",
    isAuthProtected: false,
  },
  {
    layout: <Leaderboard />,
    path: "leaderboard",
    name: "Leaderboard",
    isAuthProtected: true,
  },
  {
    layout: <Mission />,
    path: "mission",
    name: "Mission",
    isAuthProtected: true,
  },
  {
    layout: <Loyalty />,
    path: "loyalty",
    name: "Loyalty",
    isAuthProtected: true,
  },
  {
    layout: <NotFound />,
    path: "/not-found",
    name: "NotFound",
    isAuthProtected: false,
  },
  {
    layout: <CasinoSection />,
    path: "/casino",
    name: "CasinoSection",
    isAuthProtected: true,
  },
  {
    layout: <CasinoProvider />,
    path: "/casino-provider",
    name: "CasinoProvider",
    isAuthProtected: true,
  },
  {
    layout: <CasinoGames />,
    path: "/casino-games/:category",
    name: "CasinoGames",
    isAuthProtected: true,
  },
  {
    layout: <Wallet />,
    path: "/wallet",
    name: "Wallet",
    isAuthProtected: true,
  },
  {
    layout: <ProfileDetails />,
    path: "/profile-details",
    name: "ProfileDetails",
    isAuthProtected: true,
  },
  {
    layout: <PaymentDetails />,
    path: "/payment-details",
    name: "PaymentDetails",
    isAuthProtected: true,
  },
  {
    layout: <MyBets />,
    path: "/my-bets",
    name: "MyBets",
    isAuthProtected: true,
  },
  {
    layout: <BetProfitLoss />,
    path: "/bet-profit-loss",
    name: "BetProfitLoss",
    isAuthProtected: true,
  },
  {
    layout: <ProviderGames />,
    path: "/provider-games",
    name: "ProviderGames",
    isAuthProtected: true,
  },
  {
    layout: <CMS />,
    path: "/cms/:id",
    name: "CMS",
    isAuthProtected: false,
  },
  {
    layout: <GameSection />,
    path: "/game-section",
    name: "GameSection",
    isAuthProtected: true,
  },
  {
    layout: <Bonus />,
    path: "/bonus",
    name: "Bonus",
    isAuthProtected: true,
  },
  {
    layout: <ContactUs />,
    path: "/contact-us",
    name: "Contact Us",
    isAuthProtected: false
  }

];
